import { render, staticRenderFns } from "./xinyongkaedu.vue?vue&type=template&id=18fe046b&"
import script from "./xinyongkaedu.vue?vue&type=script&lang=js&"
export * from "./xinyongkaedu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports